var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaginatedMessagesDialog',{attrs:{"value":_vm.value,"groups":_vm.resolvedGroups,"labels-prefix":_vm.labelsPrefix,"group-labels-prefix":`${_vm.labelsPrefix}.types`,"close-label":_vm.closeButtonLabel},on:{"input":function($event){return _vm.$emit('input', $event)},"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }